import axios from 'axios';
import store from '@Store';

const BASE_URL = {
  PRODUCTION: 'https://harcravmth.execute-api.ap-northeast-2.amazonaws.com/prod',
  DEV: 'https://d124euv8mk.execute-api.ap-northeast-2.amazonaws.com/dev',
};

const errorHandler = error => {
  const { response } = error;

  // eslint-disable-next-line prefer-promise-reject-errors
  return Promise.reject({ status: response?.status, msg: response?.data.msg });
};

const requestHandler = async config => {
  try {
    const { accessToken } = store.getState().user;

    if (!config.headers.Authorization && accessToken) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = accessToken;
    }
  } catch (error) {
    console.error('Axios interceptors request', error);
  }

  return config;
};

const responseHandler = response => {
  return response.data;
};

const customAxios = axios.create({
  baseURL: `${BASE_URL[process.env.REACT_APP_STAGE]}`,
});

customAxios.interceptors.request.use(requestHandler);

customAxios.interceptors.response.use(
  response => responseHandler(response),
  error => errorHandler(error),
);

export default customAxios;
